import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getCurrentUserId, setIngredientsLoaded, setSupplementsLoaded } from 'store/storeValtio';
import Spinner from '../spinner/Spinner';
import { addIngredientsToMed } from 'helpers/ingredientHelpers.js';
import { getIngredientsFromDb } from 'store/localDb';

export default function SupIngredientList({med, labelId}) {
  const currentUserId = getCurrentUserId();
  const navigate = useNavigate();

  console.log('SupIngredientList', labelId);

  const [label, setLabel] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    console.log('SupIngredientList UE');
    async function getLabel(labelId) {
        try{
            const url = `https://api.itookitwhen.com/Supplement/${labelId}`;
            const response = await fetch(url);
            const result = await response.json();
            console.log('label UE', result);
            setLabel(result);
            setLoading(false);
        }catch(error) {
            return [];
        }
      }
      getLabel(labelId)
  },[]);

  async function addIngredients() {
    await addIngredientsToMed(med, label);
    console.log('ingredients added')
    setSupplementsLoaded(false);
    setIngredientsLoaded(false);
    getIngredientsFromDb();
    navigate(`/ingredients/${med.medicationId }`);
  }

  if (loading) {
    console.log('ingredSupIngredientList loading');
    return(<Spinner />);
  }

  return (
    <>
      <div className='supBody'>
        {/* <div className='grid grid-cols-2 gap-2 text-xl font-bold'> */}
        <table id='supps' className='w-10/12 mt-4 text-base small:text-lg font-semibold'>
          <thead></thead>
          <tbody>
            <tr>
            <td>Name</td>
            <td>{label.name}</td>
            </tr>
            <tr>
            <td>Brand</td>
            <td>{label.brand}</td>
            </tr>
            <tr>
            <td>Contents</td>
            <td>{label.contents}</td>
            </tr>
            </tbody>
        </table>
      </div>
      <div className='mx-1 px-2'>
        <table id='supps' className='w-full mt-4 text-base small:text-lg font-semibold'>
          <thead>
            <tr>
              <th className='w-9/12'>Ingredient</th>
              <th>Amount</th>
            </tr>
          </thead>
        </table>
      </div>
      <div className='lcard'>
        <table id='supps' className='w-full text-base small:text-lg font-semibold'>
          <tbody>
            {label.ingredients.map((i,ix) => {
                //const li = bn.name === medsCreateState.brand ? 'py-1 bg-green-300' : 'py-1 bg-slate-300';
                return (
                  <tr key={ix} className='ingItem'>
                    <td className='w-9/12'>
                    {i.name} 
                    </td>
                    <td>
                    {i.quantity} {i.unit}
                    </td>
                  </tr>
                    )
                })}
        </tbody>
      </table>
    </div>
    <div className='my-2 text-center text-2xl'>
      <button className='rawBtn px-4 border-2 border-black bg-blue-400'
        onClick={()=>addIngredients()}>
        Add Ingredients to Medication
      </button>
    </div>
  </>
  )
}